import { createFileRoute } from "@tanstack/react-router";
import { TeamsUsersScreen } from "../screens/TeamsUsersScreen";

export const Route = createFileRoute("/_app/team-users")({
  component: TeamsUsersScreen,
});
